<template>
<!-- Sidebar -->
<ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

  <!-- Sidebar - Brand -->
  <a class="sidebar-brand d-flex align-items-center justify-content-center" href="index.html">
    <div class="sidebar-brand-icon rotate-n-15">
      <i class="fas fa-laugh-wink"></i>
    </div>
    <div class="sidebar-brand-text mx-3">DAMDA <sup>admin</sup></div>
  </a>

  <!-- Divider -->
  <hr class="sidebar-divider my-0">

  <!-- Nav Item - Dashboard -->
  <li class="nav-item active">
    <router-link to="/" class="nav-link">
      <i class="fas fa-fw fa-tachometer-alt"></i>
      <span>MAIN</span>
    </router-link>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
    회원 관리
  </div>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
      <i class="fas fa-fw fa-building"></i>
      <span>기업협의회 관리</span>
    </a>
    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Custom Components:</h6>
        <a class="collapse-item" href="buttons.html">목록조회</a>
        <a class="collapse-item" href="cards.html">신규등록</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Utilities Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities" aria-expanded="true" aria-controls="collapseUtilities">
      <i class="fas fa-fw fa-user"></i>
      <span>사용자 회원 관리</span>
    </a>
    <div id="collapseUtilities" class="collapse" aria-labelledby="headingUtilities" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">Custom Utilities:</h6>
        <router-link to="/admin/user" class="collapse-item" >승인 대기 회원</router-link>
        <router-link to="/admin/user" class="collapse-item" >회원 목록 조회</router-link>
      </div>
    </div>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
    분석 관리
  </div>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages" aria-expanded="true" aria-controls="collapsePages">
      <i class="fas fa-fw fa-user"></i>
      <span>분석 사용자 관리</span>
    </a>
    <div id="collapsePages" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">사용자 요청:</h6>
        <a class="collapse-item" href="/admin/user">목록 조회</a>
        <div class="collapse-divider"></div>
        <h6 class="collapse-header">AWS 관리:</h6>
        <a class="collapse-item" href="/">기업목록 조회</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseAnalysisShare" aria-expanded="true" aria-controls="collapseAnalysisShare">
      <i class="fas fa-fw fa-chart-line"></i>
      <span>분석 사례 공유</span>
    </a>
    <div id="collapseAnalysisShare" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">분석 사례 관리:</h6>
        <a class="collapse-item" href="login.html">목록 조회</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Charts -->
  <li class="nav-item">
    <a class="nav-link" href="charts.html">
      <i class="fas fa-fw fa-chart-area"></i>
      <span>분석의뢰</span></a>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
    서비스 관리
  </div>

  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseAnalysisQuest" aria-expanded="true" aria-controls="collapseAnalysisQuest">
      <i class="fas fa-fw fa-clipboard-list"></i>
      <span>Support 관리</span>
    </a>
    <div id="collapseAnalysisQuest" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">공지사항 관리:</h6>
        <a class="collapse-item" href="login.html">공지사항 목록 조회</a>
        <a class="collapse-item" href="login.html">공지사항 등록</a>
        <div class="collapse-divider"></div>
        <h6 class="collapse-header">FAQ 관리:</h6>
        <a class="collapse-item" href="login.html">FAQ 목록 조회</a>
        <a class="collapse-item" href="login.html">FAQ 등록</a>
        <div class="collapse-divider"></div>
        <h6 class="collapse-header">1:1 문의 관리:</h6>
        <a class="collapse-item" href="login.html">문의 목록 조회</a>
        <a class="collapse-item" href="login.html">답변 등록</a>
      </div>
    </div>
  </li>

  <!-- Nav Item - Tables -->
  <li class="nav-item">
    <a class="nav-link" href="tables.html">
      <i class="fas fa-fw fa-download"></i>
      <span>다운로드 관리</span></a>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
    시스템 관리
  </div>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
    <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseOAuthClient" aria-expanded="true" aria-controls="collapseOAuthClient">
      <i class="fas fa-fw fa-server"></i>
      <span>연동 시스템 관리</span>
    </a>
    <div id="collapseOAuthClient" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
      <div class="bg-white py-2 collapse-inner rounded">
        <h6 class="collapse-header">OAuth ID 관리:</h6>
        <router-link to="/admin/oauthclient" class="collapse-item" >목록 조회</router-link>
      </div>
    </div>
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider d-none d-md-block">

  <!-- Sidebar Toggler (Sidebar) -->
  <div class="text-center d-none d-md-inline">
    <button class="rounded-circle border-0" id="sidebarToggle"></button>
  </div>

</ul>
<!-- End of Sidebar -->
</template>

<script>
export default {
  name: 'main-aside'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/MainAside.vue